exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--light.v-application,body,html{background:none transparent}.widgets-wrapper{position:absolute;bottom:10px}.lr-input input{height:42px;line-height:42px;max-height:42px;margin-right:-29px}.lr-input .theme--light.v-text-field>.v-input__control>.v-input__slot:after,.lr-input .theme--light.v-text-field>.v-input__control>.v-input__slot:before{display:none}#lr-widget-html,#lr-widget-seo-html{margin-top:15px;margin-bottom:15px}.v-card.v-sheet.theme--light{border-color:rgba(0,0,0,.14)}", ""]);

// exports
